import { Employee } from './employee.model';
import { Course, Discount, Product, ProductCategory, Resource, Session } from './resource.model';
import { ResourceType } from './resourceType.model';
import { Branch } from './Branch.model';
import { Terminal } from './Terminal.model';
import { AptView } from './appointment-book.models';
import { CustomerSettingsData } from 'src/app/services/customer-settings.service';
import { ReasonCode } from './ReasonCode';
import { Disclaimer } from './disclaimer.model';
import { Gender } from './gender.model';
import { AS365FeatureFlags } from 'src/app/services/default-data.service';
import { OnlineSalesSettings } from 'src/app/services/online-sales.service';
import { MarketingSettingsData } from 'src/app/services/marketing-settings.service';
import { PayPoint } from './PayPoint.model';
export class KeyValuePair {
  Key = '';
  Value = '';

  public static CreateFrom(s: KeyValuePair) {
    if (!s) {
      return null;
    }
    const t = new KeyValuePair();
    t.Key = s.Key;
    t.Value = s.Value;
    return t;
  }
}

export class LookupItem{
  Value = -1;
  Text = '';

  public static CreateFrom(s: LookupItem) {
    if (!s) {
      return null;
    }
    const t = new LookupItem();
    t.Value = s.Value;
    t.Text = s.Text;
    return t;
  }
}
export class AS365Defaults {
  public distLocation = 'ClientApp/';
  public AppTitle = 'ActiveSalon Cloud';
  public WebAPIVersion = '0.0.0.2';
  public SupportPhone = '0161 507 1598';
  public get Copyright() 
  {
    var d:Date = new Date();
    return 'SolarTrack Systems Ltd (c) 2021-'+ d.getFullYear();
  } 

  public MinHWCVersion = '2021.01.01.1';

  public AS365HWCUrl = 'https://as365hwc.local';
  public PublicIPURL = 'https://as365.azurewebsites.net/MyPublicIP';

  public CustomerName = '';
  public TenantUid = '';
  public Branches: Branch[] = [];
  public Terminals: Terminal[] = [];
  public Employees: Employee[];
  public Sessions: Session[];
  public ResourceTypes: ResourceType[];
  public Resources: Resource[];
  public Courses: Course[];
  public Products: Product[];
  public  Discounts: Discount[];
  
  public ReasonCodes: ReasonCode[];
  public customerSettings: CustomerSettingsData = new CustomerSettingsData();
  public marketingSettings: MarketingSettingsData = new MarketingSettingsData();
  public onlineSalesSettings: OnlineSalesSettings = new OnlineSalesSettings();
  public Disclaimers: Disclaimer[];
  public aptViews: AptView[];
  public AuthEmployeeId = -1;
  public ReportList: KeyValuePair[] = [];
  public GenderList: Gender[];
  public FeatureQueueManagerEnabled: boolean = false;
  public Locale: string;
  public AS365FeatureFlags: AS365FeatureFlags=new AS365FeatureFlags();
  public CampaignFilters: LookupItem[] = [];
  public ResourceAvailabilityPollingInterval: number = 5;
  public PayPoints: PayPoint[] = [];
  public IPSCloudUrl: string;
  public LicenceExpiry: Date;

  public get ActiveBranches(): Branch[] {
    return (this.Branches) ? this.Branches.filter(i => i.Enabled === true) : [];
  }

  public get ActivePayPoints(): PayPoint[] {
    return (this.PayPoints) ? this.PayPoints.filter(i => i.Active === true): [];
  }

  public GetBranchFromId(Id: number): Branch {
    return this.Branches.find(i => i.BranchId === Id);
  }

  public GetBranchFromUId(UId: String): Branch {
    return this.Branches.find(i => i.UID === UId);
  }

  public GetTerminalFromId(Id: number): Terminal {
    return this.Terminals.find(i => i.Id === Id);
  }
}
